/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Page,
  Document as PDFDocument,
  StyleSheet as PDFStyleSheet,
  Font,
  View,
  Text as PDFText
} from '@react-pdf/renderer'

import { BookingDetail } from '../../../../types/bookingDetails'
import PromotionDetails from '../../PromotionDetails'
import IRANSans from '../assets/ttf/IRANSansWeb.ttf'
import IRANSansBold from '../assets/ttf/IRANSansWeb_Bold.ttf'
import { CancelTermsAndConditions } from './CancelTermsAndConditions'
import Footer from './Footer'
import { ModifyTermsAndConditions } from './ModifyTermsAndConditions'
import { PriceDetails } from './PriceDetails'
import RatePolicy from './RatePolicy'
import RenderParts from './RenderParts/RenderParts'
import { RoomDetails } from './RoomDetails'
import Title from './Title'

Font.register({
  family: 'IRANSans',
  fonts: [
    {
      src: IRANSans,
      fontWeight: 400
    },
    {
      src: IRANSansBold,
      fontWeight: 700
    }
  ]
})
const styles = PDFStyleSheet.create({
  page: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'IRANSans',
    flexWrap: 'wrap',
    paddingTop: 20,
    paddingBottom: 70,
    paddingHorizontal: 20
  },
  main: {
    flexGrow: 1,
    width: '100%',
    alignItems: 'center'
  },
  roomContianer: {
    marginTop: 10,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },
  divider: {
    height: 1,
    width: '90%',
    borderBottom: '1px dashed black',
    marginBottom: 24
  }
})

interface MainPageProps {
  data: BookingDetail
  masterReservationNumber: string
  stripTagsWithNewlines(html: string): string[]
  splitTextByWords(inputString: string, maxLength: number): string[]
}

const MainPage = ({
  data,
  masterReservationNumber,
  stripTagsWithNewlines,
  splitTextByWords
}: MainPageProps) => {
  return (
    <PDFDocument>
      <Page size="A4" style={styles.page}>
        <View style={styles.main} wrap>
          <Title />
          <RenderParts
            data={data}
            masterReservationNumber={masterReservationNumber}
          />
          <PromotionDetails application={data.promotionApplication} rtl />
          {data.rooms.map((item, index) => (
            <View key={index} style={styles.roomContianer} wrap>
              {index !== 0 && <View style={styles.divider} />}
              <RoomDetails
                data={item}
                index={index}
                currency={data.basicDetails.currency}
              />
              <PriceDetails data={item} currency={data.basicDetails.currency} />
              {item.cancellationPolicy.policies &&
                item.cancellationPolicy.policies.length > 0 && (
                  <CancelTermsAndConditions
                    cancelPolicies={item.cancellationPolicy.policies}
                    cancelPolicyDescription={
                      item.cancellationPolicy.descriptionTranslatedList[0].value
                        ? stripTagsWithNewlines(
                            item.cancellationPolicy.descriptionTranslatedList[0]
                              .value
                          )
                        : []
                    }
                    splitTextByWords={splitTextByWords}
                  />
                )}
              {item.modificationPolicy.policies &&
                item.modificationPolicy.policies.length > 0 && (
                  <ModifyTermsAndConditions
                    modifyPolicies={item.modificationPolicy.policies}
                    modifyPolicyDescription={
                      item.modificationPolicy.descriptionTranslatedList[0].value
                        ? stripTagsWithNewlines(
                            item.modificationPolicy.descriptionTranslatedList[0]
                              .value
                          )
                        : []
                    }
                    splitTextByWords={splitTextByWords}
                  />
                )}
              <RatePolicy
                text={item.ratePolicyTranslatedList?.[0]?.value || ''}
              />
            </View>
          ))}
        </View>
        <View
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 50
          }}
          fixed>
          <Footer
            phone={data.basicDetails.propertyTelephone}
            website={data.basicDetails.propertyWebsite}
          />
        </View>
      </Page>
    </PDFDocument>
  )
}

export default MainPage
